module.exports = __webpack_public_path__ + "static/img/knowledge.8f1c277d.png";